"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAddress = exports.AddressStruct = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
exports.AddressStruct = (0, superstruct_1.type)({
    companyName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    streetAddress1: (0, superstruct_1.string)(),
    streetAddress2: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    postalCode: (0, superstruct_1.string)(),
    city: (0, superstruct_1.string)(),
    country: (0, superstruct_1.string)(),
    deliveryOption: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    location: (0, superstruct_1.type)({
        latitude: (0, superstruct_1.number)(),
        longitude: (0, superstruct_1.number)(),
    }),
});
function isAddress(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.AddressStruct, "Address");
}
exports.isAddress = isAddress;
